import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDreamteam = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "dreamteam" }),
		/* @__PURE__ */ _jsx("g", {
			id: "icon_circle",
			"data-name": "icon circle",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 16
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "symbol_star",
			"data-name": "symbol star",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M22.13,26L16,21.5,9.75,26l2.13-7.5L6,13.63l7.5-.25L16,6l2.5,7.5L26,13.75,20,18.5Z",
				fill: "currentColor"
			})
		})
	]
});
export default SvgDreamteam;
